module.exports = __webpack_public_path__ + "static/img/11.082f8ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/11.png
// module id = t+pZ
// module chunks = 0